










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import MyActionReportContent from '@/components/action_report/MyActionReportContent.vue';

@Component({
  components: {
    Header,
    MyActionReportContent,
    Footer,
  },
})
export default class MyActionReport extends Vue {}
